"use client";

import React from "react";
import { Button, ConfigProvider, Flex, Grid, Typography } from "antd/lib";
import { useTranslation } from "react-i18next";
import theme from "@/src/theme/themeConfig";

const { Title } = Typography;

const { useBreakpoint } = Grid;

const ErrorFallback: React.FC = () => {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const clickHandler = () => {
    if (typeof window === "undefined") return;

    window.location.reload();
  };

  return (
    <ConfigProvider theme={theme}>
      <Flex gap={24} vertical justify="center" align="center" style={{ padding: 24 }}>
        <Title level={1} style={{ textAlign: "center" }}>
          {t("common.messages.somethingWentWrong")}
        </Title>

        <Button type="primary" onClick={clickHandler} style={{ width: screens.sm ? "auto" : "100%" }}>
          {t("common.actions.reload")}
        </Button>
      </Flex>
    </ConfigProvider>
  );
};

export default ErrorFallback;
